import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";

export const InputWrapper = styled(FlexDiv)`
  flex-direction: column;
`;

export const InputGroup = styled(FlexDiv)`
  flex-direction: column;
  position: relative;
  margin-bottom: ${({ showLabels }) => (showLabels ? "25px" : "35px")};
`;
